var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNaveridlogin = function SvgNaveridlogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 15,
    rx: 2,
    fill: "#03C75A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.336 4.25V8L7.555 4.25H5.25v7.5h2.415V8l2.78 3.75h2.305v-7.5h-2.414Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#naveridlogin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.327 9.085h-3.025v1.639h3.883v.902H16.33v-.902h3.85V9.085h-2.717V5.917h5.456V4.652H17.43V3.75h6.611v3.08h-5.445v1.342h5.731v.913Zm10.076 2.354h-8.855v-.913h8.855v.913Zm-1.155-7.315c0 2.596-.165 4.433-.43 5.72l-1.11-.143c.242-.979.407-3.102.407-4.686H26.57v-.891h6.677Zm9.58 6.05h-1.122V3.068h1.122v7.106Zm.231 2.409h-6.71v-3.08h1.122v2.178h5.588v.902Zm-2.98-6.391c0 1.397-1.013 2.398-2.509 2.398s-2.53-1.001-2.53-2.387c0-1.397 1.023-2.409 2.53-2.409 1.496 0 2.508 1.001 2.508 2.398Zm-1.123 0c0-.858-.528-1.463-1.386-1.463-.836 0-1.397.627-1.397 1.463 0 .803.561 1.441 1.397 1.441.858 0 1.386-.638 1.386-1.441Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "naveridlogin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16 2)",
    d: "M0 0h28v12H0z"
  })))));
};
export default SvgNaveridlogin;